var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1920-arrow-down",
    clipPath: "url(#clip0_1464_8447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 7.25C8.75 7.25 7.34681 8.40663 6.60714 9.39286C5.86748 10.3791 5 12.25 5 12.25C5 12.25 4.13252 10.3791 3.39286 9.39286C2.65319 8.40663 1.25 7.25 1.25 7.25",
    stroke: "#1E1D1C",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.00037 0.999962L5 11",
    stroke: "#1E1D1C",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1464_8447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.960822c447fb6e73effa61e1347b5e81.svg";
export { ForwardRef as ReactComponent };